"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownList = DropdownList;
var React = _interopRequireWildcard(require("react"));
var styles = _interopRequireWildcard(require("./styles.css"));
var _uiKit = require("@cian/ui-kit");
var _classnames = _interopRequireDefault(require("classnames"));
var _types = require("../../../../types");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function DropdownList(props) {
  const {
    value,
    values,
    onValueChange
  } = props;
  return /*#__PURE__*/React.createElement("ul", {
    className: styles['list']
  }, values.map((option, i) => {
    const optionValue = option.value;
    const isActive = optionValue === value;
    if (optionValue === _types.dropdownSeparator) {
      return /*#__PURE__*/React.createElement("li", {
        key: i,
        className: styles['separator']
      });
    }
    return /*#__PURE__*/React.createElement("li", {
      key: `${optionValue}`
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: (0, _classnames.default)(styles['button'], {
        [styles['button__active']]: isActive
      }),
      onClick: () => onValueChange(optionValue)
    }, isActive && /*#__PURE__*/React.createElement("span", {
      className: styles['button-active-icon']
    }, /*#__PURE__*/React.createElement(_uiKit.IconSuccess16, {
      color: "primary_100",
      display: "block"
    })), /*#__PURE__*/React.createElement(_uiKit.UIText2, null, option.selectedLabel)));
  }));
}